import { IQuiz } from '../IQuiz'

export const lspIntro1: IQuiz = {
  name: 'lsp-intro-1',
  question: 'В чём суть принцип подстановки Барбары Лисков?',
  variants: [
    {
      text: 'Проектировать сущности так, чтобы их потомки не противоречили базовому поведению'
    },
    {
      text: 'Проектировать сущности так, чтобы их иерархия повторяла иерархию реальных объектов',
      description:
        'Моделируя систему, мы описываем поведение её компонентов. Иерархия — удобный инструмент для моделирования, но она может приводить к неправильному описанию поведения'
    },
    {
      text:
        'Проектировать сущности так, чтобы их потомков можно было подменять одного на другой без изменения функции, которая их использует'
    },
    {
      text: 'Проектировать сущности так, чтобы с каждым уровнем наследования методы усиливали предусловия',
      description: 'Принцип подстановки Лисков требует, чтобы предусловия оставались теми же'
    }
  ],
  meta: {
    correctAnswers: [0, 2]
  }
}
